export function ServiceResponceToElement(serviceResponse: any): any {
  const initialValues: any = {
    offer: {
      ofrid: 0,
      ofrtype: '',
      ofrlabel: '',
      ofrdescription: '',
    },
    ofrid: 0,
    ofrlabel: '',
    ofrtype: '',
    assetid: 0,
    conElemAssets: [],
    conElemSchedules: [],
    conElemSteps: [],
    conElemAttributes: [],
    conElemServiceSteps: [],
    ctebilligdate: '',
    cteactuarialrate: 0,
    ctecalculationbasis: '',
    ctecalculationtype: '',
    ctecategory: serviceResponse?.servcode,
    ctecategorylabel: serviceResponse?.servlabel,
    ctedeferredinterest: 0,
    ctedeferredinterestmethod: '',
    ctedeferredinterestnominalrate: null,
    ctedepositamount: null,
    ctedepositcoef: null,
    ctedepositinterest: 0,
    ctedepositinterestmethod: '',
    ctedepositnominalrate: null,
    ctedescription: '',
    ctedirection: '',
    cteduration: 0,
    cteendamount: 0,
    cteenddate: '',
    ctefinancedamount: 0,
    ctefirstpayment: 0,
    ctefirstpaymentcoef: 0,
    ctefirstpaymentdate: null,
    ctefree1: '',
    ctegraceperiodduration: 0,
    ctegraceperiodmethod: '',
    cteid: 0,
    cteidparent: 0,
    cteinitialamount: 0,
    cteinstallmentamount: 0,
    cteinterestmethod: '',
    cteinvestamount: 0,
    ctenominalrate: 0,
    cteorder: 0,
    ctepartamount: 0,
    ctepartdays: 0,
    ctepartmethod: '',
    ctepartrate: 0,
    ctepaymentterm: '',
    cteperiodicity: '',
    cteratebasis: '',
    cterateformula: '',
    cterateperiodicity: '',
    cteratespread: 0,
    cterateterm: '',
    cteratetype: '',
    cterentalamount: 0,
    ctervamount: 0,
    ctervcoef: 0,
    ctestartamount: 100000,
    ctestartdate: '',
    ctestatus: '',
    ctetype: 'SERV',
    cteunit: '',
    cteupfrontamount: 0,
    ctrid: 0,
    currcode: '',
    ctemileage: 0,
    ctepriidexceed: 0,
    last_action: '',
    prefinbasis: '' as any,
    prefinmethod: '',
    prefinnominalrate: '' as any,
    prefinperiodicity: '' as any,
    prefinrateformula: '' as any,
    prefinratetype: '' as any,
    rvcalculationmode: '',
    rvevaluationmode: '',
    prefinrateref: '' as any,
    prefinratespread: 0,
    cterateref: 0,
    priid: 0,
    taxcode: serviceResponse?.taxcode,
    taxrate: 0,
    taxtype: '' as any,
    tpid: 0,
    tpidparticipation: '' as any,
    deferredinterestratetype: 0,
    pritype: '',
    helpers: {
      servfixedamountmin: '' as any,
      servpercentagemin: '' as any,
      servcontextmin: '' as any,
      durationmax: 0,
      durationcontextmax: 0,
      durationcontextmin: 0,
      durationmin: 0,
      frmin: 0,
      frmax: 0,
      frcontextmax: 0,
      frcontextmin: 0,
      upmax: 0,
      upmin: 0,
      rvmax: 0,
      rvmin: 0,
      rvcontextmax: 0,
      rvcontextmin: 0,
      marginratemin: '' as any,
      margincontextmin: '' as any,
      marginratemax: '' as any,
      margincontextmax: '' as any,
      gpdurationmax: '' as any,
      ratemax: 0,
      ratemin: 0,
      ratecontextmax: 0,
      ratecontextmin: 0,
    },
    spvassetdiscount: '' as any,
    spvriskrate: '' as any,
    spvadditionalfees: '' as any,
    spvloancoef: '' as any,
    spvdiscountsale: '' as any,
    spvinflation: '' as any,
    serviceResponse: { ...serviceResponse },
    commissionResponse: [],
    serviceStepList: [],
    pricing: {
      priid: 0,
      prilabel: '',
      cteid: 0,
      ctetype: 'SERV' as any,
      ctecategory: serviceResponse?.servcode ?? '',
      finamountmin: 0,
      finamountmax: 0,
      calculationmethod: '',
      calculationbasis: '',
      rateformula: '',
      ratetype: '',
      rateperiodicity: 0,
      ratevaluedefault: 0,
      ratespreadmin: 0,
      ratespreadmax: 0,
      ratespreaddefault: 0,
      ratereqtype: '',
      ratereqreceivertype: '',
      ratereqreceiverroleprofile: '',
      ratereqreceiverid: 0,
      durationmin: 0,
      durationmax: 0,
      durationdefault: 0,
      durationreqtype: '',
      durationreqreceivertype: '',
      durationreqreceiverroleprofile: '',
      durationreqreceiverid: 0,
      periodicity: '',
      unit: '',
      interestmethod: '',
      term: '',
      gpduration: '' as any,
      gpmethod: '',
      firstrentalmin: 0,
      firstrentalmax: 0,
      firstrentaldefault: 0,
      firstrentalreqtype: '',
      firstrentalreqreceivertype: '',
      firstrentalreqreceiverroleprofile: '',
      firstrentalreqreceiverid: 0,
      rvmin: '' as any,
      rvmax: '' as any,
      rvdefault: '' as any,
      rvreqtype: '',
      rvreqreceivertype: '',
      rvreqreceiverroleprofile: '',
      rvreqreceiverid: 0,
      serviceduration: '' as any,
      servcalculationmethod: '' as any,
      servreqtype: '' as any,
      servreqreceivertype: '' as any,
      servreqreceiverroleprofile: '' as any,
      servreqreceiverid: '' as any,
      pristatus: '',
      startdate: '',
      enddate: '' as any,
      pridescription: '' as any,
      servfixedamountmin: '' as any,
      servpercentagemin: '' as any,
      ctebilligdate: '' as any,
      flagmandatory: false,
      flagupdate: false,
      taxcode: '',
      deferredinterestmethod: '',
      deferredinterestnominalrate: '' as any,
      depositamount: '' as any,
      depositcoef: '' as any,
      depositinterestmethod: '',
      depositnominalrate: '' as any,
      rvdefaultamount: 0,
      flagfollowgraceperiod: false,
      prefinmethod: '',
      prefinnominalrate: '' as any,
      prefinbasis: '' as any,
      prefinperiodicity: '' as any,
      prefinratetype: '' as any,
      prefinrateformula: '' as any,
      partmethod: '',
      partamount: '' as any,
      partrate: '' as any,
      tpidparticipation: '' as any,
      partnbdays: 0,
      tprole: '' as any,
      allowfinservice: false,
      upfrontmin: 0,
      upfrontmax: 0,
      upfrontdefault: 0,
      upfrontreqtype: '',
      upfrontreqreceivertype: '',
      upfrontreqreceiverroleprofile: '',
      upfrontreqreceiverid: 0,
      spvassetdiscount: '' as any,
      spvriskrate: '' as any,
      spvadditionalfees: '' as any,
      spvloancoef: '' as any,
      spvdiscountsale: '' as any,
      spvinflation: '' as any,
      rvcontextmax: '' as any,
      rvcontextmin: '' as any,
      rvauthid: '' as any,
      rvtaskid: '' as any,
      ratecontextmax: '' as any,
      ratecontextmin: '' as any,
      rateauthid: '' as any,
      ratetaskid: '' as any,
      frcontextmax: '' as any,
      frcontextmin: '' as any,
      frauthid: '' as any,
      frtaskid: '' as any,
      durationcontextmax: '' as any,
      durationcontextmin: '' as any,
      durationauthid: '' as any,
      durationtaskid: '' as any,
      rvcalculationmode: '' as any,
      rvevaluationmode: '' as any,
      cttype: '' as any,
      currcode: '' as any,
      marginratemin: '' as any,
      marginratemax: '' as any,
      marginratedefault: '' as any,
      marginratereqtype: '' as any,
      marginratereqreceivertype: '' as any,
      marginratereqreceiverroleprofile: '' as any,
      marginratereqreceiverid: '' as any,
      margincontextmin: '' as any,
      margincontextmax: '' as any,
      marginauthid: '' as any,
      margintaskid: '' as any,
      servcontextmin: '' as any,
      servauthid: 0,
      servtaskid: 0,
    },
    pricingStepList: [],
    rvauthid: 0,
    rvtaskid: 0,
    rateauthid: 0,
    ratetaskid: 0,
    frauthid: 0,
    frtaskid: 0,
    durationauthid: 0,
    durationtaskid: 0,
    servtaskid: 0,
    servauthid: 0,
    margintaskid: 0,
    marginauthid: 0,
    ctefeesamount: 0,
    ctecommissionamount: 0,
    cteprofitabilityrate: 0,
    cteaprrate: 0,
    cteflatrate: 0,
    ctecoefrate: 0,
    ctefundingrate: 0,
    ctefundingperiodicity: 0,
    ctefundinginstallment: 0,
    ctefundingcost: 0,
    ctemarginamount: 0,
    ctemarginrate: 0,
    ctevatdeferralamount: 0,
    ctevatdeferralduration: 0,
    ctevatdeferralmethod: '',
    ctevatdeferraldaysbasis: 0,
    cteextracosttofinance: 0,
    cteextracostcomment: '',
    totalInterest: 0,
    totalRental: 0,
    totalAmortization: 0,
    totaldiscountedInterest: 0,
    totalVatDeffered: 0,
    totaldiscountedOutstanding: 0,
    totaldiscountedAgiosdeb: 0,
    totalAgiosdeb: 0,
    marginImpactCredit: 0,
    marginImpactDebit: 0,
    dgo: 0,
    profitabilityAmount: 0,

    servfixedamount: serviceResponse?.servfixedamount,
    servpercentage: serviceResponse?.servpercentage ?? 0,
    additionalcostaftermargin: serviceResponse?.additionalcostaftermargin,

    servbasisamount: serviceResponse?.servfreebasisdefault ?? 0,

    prilabel: serviceResponse?.servlabel ?? 0,
    servbasis:
      serviceResponse.servbasis === ''
        ? serviceResponse.servbasislabel
        : serviceResponse.servbasis ?? '',

    calculatedamountbasis:
      serviceResponse.calculatedamountbasis === ''
        ? serviceResponse.calculatedamountbasislabel
        : serviceResponse.calculatedamountbasis ?? '',

    marginoncalulatedcamount: serviceResponse.marginoncalulatedamount ?? 0,

    servcalculationmethod:
      serviceResponse.servcalculationmethod === ''
        ? serviceResponse.servcalculationmethodlabel
        : serviceResponse.servcalculationmethod ?? '',

    servduration: serviceResponse.servduration ?? '',

    servdurationdefault: serviceResponse.servdurationdefault ?? 0,
    servperiodicity: serviceResponse.servperiodicity ?? '',

    servtype: serviceResponse.servtype ?? '',
    servusecoverage:serviceResponse.servusecoverage,
    servusedeductionamount:serviceResponse.servusedeductionamount,
    servusedeductionpercenrage:serviceResponse.servusedeductionpercenrage,
    servusefrequency:serviceResponse.servusefrequency,
    servusemaxamount:serviceResponse.servusemaxamount,
    servuseminamount:serviceResponse.servuseminamount,
    servuseqty:serviceResponse.servuseqty,
    servuseunit:serviceResponse.servuseunit,
    servdescription:serviceResponse.servdescription,
    
  };

  return initialValues;
}
